module.exports = __webpack_public_path__ + "img/authForteCodeSecurite.11fbdd31.png";